(() => {
  if (window.__bfMobileFixesInitialized) return;
  window.__bfMobileFixesInitialized = true;

  const mobileMenu = window.matchMedia('(max-width: 989px)');

  function resetDrawer(forceClose = false) {
    if (!mobileMenu.matches) return;

    document.querySelectorAll('header-drawer').forEach((drawer) => {
      const details = drawer.querySelector(':scope > details');
      if (!details) return;

      if (forceClose) {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        details.querySelectorAll('details').forEach((nested) => {
          nested.removeAttribute('open');
          nested.classList.remove('menu-opening');
        });
        details.querySelectorAll('.submenu-open').forEach((node) => node.classList.remove('submenu-open'));
      }

      if (forceClose || !details.hasAttribute('open')) {
        details.querySelectorAll('summary[aria-expanded="true"]').forEach((summary) => {
          summary.setAttribute('aria-expanded', 'false');
        });
      }

      if (forceClose) {
        drawer.closest('.section-header')?.classList.remove('menu-open');
      }
    });

    if (forceClose) {
      document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
      document.documentElement.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      if (!mobileMenu.matches) return;

      const summary = event.target.closest?.('header-drawer > details > summary');
      if (summary && summary.parentElement?.hasAttribute('open')) {
        summary.setAttribute('aria-expanded', 'false');
      }

      const menuLink = event.target.closest?.('header-drawer a[href]');
      if (menuLink) {
        requestAnimationFrame(() => resetDrawer(true));
      }
    },
    true
  );

  window.addEventListener('bf:catalog:navigated', () => resetDrawer(true));
  window.addEventListener('pageshow', () => resetDrawer(false));
})();
